(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[141],{

/***/ 49244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play",
      function () {
        return __webpack_require__(54538);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 54538:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ PlayGround; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/layout/site-layout.tsx + 2 modules
var site_layout = __webpack_require__(65747);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/page-title/page-title.tsx
var page_title = __webpack_require__(50970);
// EXTERNAL MODULE: ../../packages/ui/src/blocks/comment-widget/comment-widget.tsx
var comment_widget = __webpack_require__(93239);
// EXTERNAL MODULE: ../../packages/ui/src/components/alert/alert.tsx
var alert_alert = __webpack_require__(63431);
;// CONCATENATED MODULE: ../../packages/ui/src/pages/play.tsx
/* provided dependency */ var process = __webpack_require__(73656);




function PlayGround() {
    const [showAlert, setShowAlert] = react.useState(true);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(site_layout/* default */.Z, {
        title: "Playground",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "space-y-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(page_title/* PageTitle */.V, {
                        children: "Playground"
                    }),
                    showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)(alert_alert/* Alert */.b, {
                        type: "info",
                        title: "Feel free to play around",
                        content: process.env.DOCKER ? "We don't remove comment automatically" : "We remove stale comments every 24 hours automatically.",
                        onClickDismiss: ()=>setShowAlert(false),
                        hideDismissButton: true
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(comment_widget/* CommentWidget */._, {})
        ]
    });
}

;// CONCATENATED MODULE: ./src/pages/play.tsx
var __N_SSG = true;



/***/ }),

/***/ 93239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CommentWidget; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var _chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17849);
/* harmony import */ var next_themes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30060);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70345);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52983);
/* harmony import */ var _components_client_only__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32631);






function CommentWidget() {
    const { resolvedTheme  } = (0,next_themes__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .F)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_client_only__WEBPACK_IMPORTED_MODULE_4__/* .ClientOnly */ .q, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                "data-chirpy-comment": true,
                "data-chirpy-theme": resolvedTheme || "system",
                className: "my-16"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_2___default()), {
                src: "/bootstrap/comment.js",
                strategy: "afterInteractive",
                "data-chirpy-domain": new URL((0,_chirpy_dev_utils__WEBPACK_IMPORTED_MODULE_5__/* .getAppURL */ .dj)()).hostname
            })
        ]
    });
}


/***/ }),

/***/ 50970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32641);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36609);
/* harmony import */ var _styles_common__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55161);








function PageTitle(_param) {
    var { children , className  } = _param, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("w-fit space-y-4", className)
    }, restProps), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Heading */ .X, {
                as: "h1",
                className: "w-fit !text-4xl font-bold !leading-none",
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("h-1 w-11 rounded", _styles_common__WEBPACK_IMPORTED_MODULE_7__/* .gradient */ .FL)
            })
        ]
    }));
}


/***/ }),

/***/ 63431:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6306);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12953);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41356);
/* harmony import */ var _icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25177);





function Alert(props) {
    var ref, ref1, ref2;
    const [style, Icon, iconButtonColor] = TYPE_STYLES[props.type];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("group relative flex w-full flex-row items-start justify-between rounded border p-4", style, (ref = props.styles) === null || ref === void 0 ? void 0 : ref.root),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-1 flex-col items-start space-y-3 sm:flex-row sm:space-y-0 sm:space-x-3", props.align === "center" ? "justify-center" : "justify-start", (ref1 = props.styles) === null || ref1 === void 0 ? void 0 : ref1.container),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                        size: 20,
                        className: ""
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "text-base font-semibold leading-tight",
                                children: props.title
                            }),
                            props.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mt-1",
                                children: props.content
                            })
                        ]
                    })
                ]
            }),
            !props.hideDismissButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_button__WEBPACK_IMPORTED_MODULE_3__/* .IconButton */ .h, {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("invisible group-hover:visible", (ref2 = props.styles) === null || ref2 === void 0 ? void 0 : ref2.dismissButton),
                onClick: props.onClickDismiss,
                "aria-label": "Dismiss",
                color: iconButtonColor,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: 18
                })
            })
        ]
    });
}
const TYPE_STYLES = {
    warn: [
        "bg-yellow-300 text-yellow-1100 border-yellow-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "yellow", 
    ],
    info: [
        "bg-primary-300 text-primary-1100 border-primary-600",
        _icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        "primary", 
    ],
    success: [
        "bg-green-300 text-green-1100 border-green-600",
        _icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z,
        "green", 
    ]
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [241,689,269,747,774,888,179], function() { return __webpack_exec__(49244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);